"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:6.0.2'] && _();
}
catch (e) { }
